import { RumInitConfiguration } from '@datadog/browser-rum';
import { ClientConfigProvider } from '../ClientConfigProvider';
import * as RuntimeConfigurationService from '../RuntimeConfigurationService/RuntimeConfigurationService.server';
export namespace DatadogConfigurationService {
    export class ConfigProvider extends ClientConfigProvider {
        public get rumSDKConfiguration(): RumInitConfiguration {
            return {
                // ZGCP image tag in the format of <branch>.<build>.<commitHash>: https://gitlab.zgtools.net/zg-container-platform/tools/zillow-k8s-deploy/-/blob/master/templates/default_service_v1/kustomize/deployment.yaml#L65
                version:
                    this.runtimeConfig.getClientAvailableEnvironmentVariable(
                        RuntimeConfigurationService.Domain.ClientAvailableConfigurationValue.DATADOG_VERSION
                    ) ?? 'unset',
                sessionSampleRate:
                    this.runtimeConfig.deploymentEnvironment ===
                    RuntimeConfigurationService.Domain.DeploymentEnvironment.LOCAL
                        ? 0
                        : 100,
                sessionReplaySampleRate:
                    this.runtimeConfig.deploymentEnvironment ===
                    RuntimeConfigurationService.Domain.DeploymentEnvironment.LOCAL
                        ? 0
                        : 100,
                applicationId: 'fc430dd3-0743-4d56-9cb9-bfa88d2a3937',
                clientToken: 'pub3200d17112556a8a5b45723e1df6cdc6',
                site: 'datadoghq.com',
                service: 'zhl-mortgage-application-center-web',
                env: this.runtimeConfig.deploymentEnvironment,
                trackUserInteractions: true,
                allowedTracingUrls: [
                    url =>
                        url.startsWith('https://zhl-mortgage-application-center-web-') ||
                        url.startsWith('https://www.qa.zillow') ||
                        url.startsWith('https://www.zillow'),
                ],
                trackResources: true,
                traceSampleRate: 100,
                trackLongTasks: true,
                traceContextInjection: 'all',
                defaultPrivacyLevel: 'mask-user-input',
                enableExperimentalFeatures: ['feature_flags'],
            };
        }
    }
}
